import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, TabContent, TabPane, AccordionBody, AccordionHeader, AccordionItem, Accordion } from "reactstrap";
import "moment-timezone";
import "moment/locale/id";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import ModalImage from "react-modal-image";
import { api } from "../../../config";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetHandoverListEngineeringState, getHandoverListEngineering } from "../../../store/handoverListEngineering/action";
import { resetProductState, getProduct } from "../../../store/product/action";
import { resetProductHandoverState, getProductHandover as onGetProductHandover, addNewProductHandover as onAddNewProductHandover, updateProductHandover as onUpdateProductHandover, deleteProductHandover as onDeleteProductHandover, getProductHandoverLoading, resetProductHandoverCreateState } from "../../../store/productHandover/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetClientState, getClient } from "../../../store/client/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";

const ProductHandover = (props) => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalMediaApplicationDoc, setModalMediaApplicationDoc] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [indexPage, setIndexPage] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, productHandovers, isProductHandoverCreated, isProductHandoverUpdate, isProductHandoverSuccess, loading, error, products, productLoading, handoverListEngineerings, handoverListEngineeringLoading, companies, companyLoading, branches, branchLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    productHandovers: state.ProductHandover.productHandovers,
    loading: state.ProductHandover.loading,
    isProductHandoverCreated: state.ProductHandover.isProductHandoverCreated,
    isProductHandoverUpdate: state.ProductHandover.isProductHandoverUpdate,
    isProductHandoverSuccess: state.ProductHandover.isProductHandoverSuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    handoverListEngineerings: state.HandoverListEngineering.handoverListEngineerings,
    handoverListEngineeringLoading: state.HandoverListEngineering.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    error: state.ProductHandover.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    products: state.Product.products,
    productLoading: state.Product.loading,
  }));

  const [productHandoverList, setProductHandoverList] = useState([]);
  const [productHandoverEngineeringList, setProductHandoverEngineeringList] = useState([]);
  const [productHandoverDoc, setProductHandoverDoc] = useState([]);
  const [productHandover, setProductHandover] = useState(null);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [handoverListEngineeringList, setHandoverListEngineeringList] = useState([]);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [checkHandoverList, setCheckHandoverList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [isEdit, setIsEdit] = useState(false);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const posData = [
    {
      options: [
        { label: "KONSUMEN", value: "KONSUMEN" },
        { label: "TEKNIK", value: "TEKNIK" },
        { label: "DEVELOPER", value: "DEVELOPER" },
        { label: "BANK", value: "BANK" },
      ],
    },
  ];

  useEffect(() => {
    if (branchSelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetProductHandoverState());
      dispatch(onGetProductHandover({ branchId: branchSelected?.value ?? "" }));
      handleGetProduct(userData?.companyId);
      handleGetHandoverListEngineering(userData?.companyId);
    }
  }, [branchSelected]);

  const handleGetHandoverListEngineering = (id) => {
    dispatch(resetHandoverListEngineeringState());
    dispatch(getHandoverListEngineering({ companyId: id, status: 2 }));
  };

  const handleGetProduct = (companyId) => {
    dispatch(resetProductState());
    dispatch(getProduct({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(productHandovers)) {
      setProductHandoverList(productHandovers.map((el) => ({ ...el, isChecked: false })));
      setInfo(productHandovers[productHandovers.length - 1]);
    }
  }, [productHandovers]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "progress-dev",
        label: "Progres Penjualan",
        isSelected: true,
        data: [],
      },
      {
        id: "debitur",
        label: "Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "marketing",
        label: "Marketing",
        isSelected: true,
        data: [],
      },
      {
        id: "blok",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "tgl_akad",
        label: "Tanggal Akad",
        isSelected: true,
        data: [],
      },
      {
        id: "bank",
        label: "Bank",
        isSelected: true,
        data: [],
      },
    ];
    const docDataCustom = handoverListEngineerings.map((el) => ({
      id: el.id,
      label: el.name,
      isSelected: true,
      data: [],
    }));

    const dataDocMerge = [...dataDoc, ...docDataCustom];

    if (productHandoverList.length > 0) {
      productHandoverList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            // const doc = dataDoc.find((d) => d.id === key);

            if (key === "product_sales") {
              const progressDev = "-";
              const debitur = Array.isArray(value) && value[0]?.sls_ds?.sales_customer?.name?.trim() ? value[0].sls_ds.sales_customer.name : "-";
              const marketing = Array.isArray(value) && value[0]?.sls_ds?.sales_agent?.name?.trim() ? value[0].sls_ds.sales_agent.name : "-";
              const blok = Array.isArray(value) && value[0]?.sls_ds?.blok?.trim() ? value[0].sls_ds.blok : "-";
              const completeAt = Array.isArray(value) && value[0]?.sls_ds?.completedat?.trim() ? value[0].sls_ds.completedat : "-";
              const bank = "-";

              const progressDevDoc = dataDocMerge.find((d) => d.id === "progress-dev");
              const debiturDoc = dataDocMerge.find((d) => d.id === "debitur");
              const marketingDoc = dataDocMerge.find((d) => d.id === "marketing");
              const blokDoc = dataDocMerge.find((d) => d.id === "blok");
              const completeAtDoc = dataDocMerge.find((d) => d.id === "tgl_akad");
              const bankDoc = dataDocMerge.find((d) => d.id === "bank");
              const handoverProdIds = data.handover_production.map((el) => el.id);

              for (const el of handoverListEngineerings) {
                const doc = dataDocMerge.find((d) => d.id.toString() === el.id.toString());
                if (!doc) continue;
                const isMatched = handoverProdIds.some((id) => id.toString() === el.id.toString());
                if (isMatched) {
                  doc.data.push("✓" ?? "✗");
                } else {
                  doc.data.push("✗");
                }
              }

              progressDevDoc.data.push(progressDev);
              debiturDoc.data.push(debitur);
              marketingDoc.data.push(marketing);
              blokDoc.data.push(blok);
              completeAtDoc.data.push(handleValidDate(completeAt));
              bankDoc.data.push(bank);
            }
          });
        }
      });
    }

    setProductHandoverDoc(dataDocMerge);
  }, [productHandoverList]);

  useEffect(() => {
    if (isProductHandoverCreated && branchSelected.value) {
      if (!isEdit) {
        dispatch(resetProductHandoverState());
        dispatch(onGetProductHandover({ branchId: branchSelected?.value ?? "" }));
      }
    }
  }, [isProductHandoverCreated]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => { 
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(products)) {
      var data = [];
      var opt = [];
      products.forEach((item, key) => {
        const name = item.name;
        const branch = item.product_branch ? item.product_branch.name : "";
        const block = item.product_block ? item.product_block.name : "";
        const id = item.id;
        var obj = { label: block + " - " + name + " / " + branch, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setProductList(data);
    }
  }, [products]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setProductHandover(null);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleProductHandoverClick = useCallback(
    (arg, type) => {
      const data = arg;
      let arrHandover = [];
      if (data.handover_production && data.handover_production.length > 0) {
        for (const d of data.handover_production) {
          arrHandover.push(d);
        }
      } else {
        for (const d of handoverListEngineerings) arrHandover.push({ id: 0, name: d.name, targetat: "", Aktualat: "", description: "" });
      }
      setCheckHandoverList(arrHandover);

      const branch = data.product_branch ? data.product_branch.name : "";
      const block = data.product_block ? data.product_block.name : "";
      setProductHandover({
        handover: arrHandover,
        handover_key: data.handover_key ? { value: data.handover_key, label: data.handover_key } : "",
        handover_acc: data.handover_acc ? { value: data.handover_acc, label: data.handover_acc } : "",
        handover_pk: data.handover_pk ? { value: data.handover_pk, label: data.handover_pk } : "",
        handoverat: data.handoverat,
        handover_desc: data.handover_desc,
        productId: data.name ? { label: block + " - " + data.name + " / " + branch, value: data.id } : "",
        branch: data.product_branch ? data.product_branch.name : "",

      });
      setIsEdit(true);
      toggle();
    },
    [toggle, handoverListEngineerings]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = productHandoverList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setProductHandoverList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 pe-0 me-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = productHandoverList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setProductHandoverList(updatedData);
            }} />
          <ButtonGroup className="m-0">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateSales") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  handleProductHandoverClick(data);
                }}>
                <i className="ri-edit-2-line fs-15"></i>
              </Button>
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        </div>
      );
    },
  },
  {
    Header: "Unit",
    accessor: "name",
    filterable: true,
    Cell: (cell) => {
      let data = cell.row.original;
      return <div className="mb-1">{data.product_block?.name + " - " + data.name}</div>;
    },
  },
  {
    id: "Blok",
    Header: "Blok",
    accessor: "product_block.name",
    filterable: true,
    Cell: (cell) => {
      let data = cell.row.original;
      return <div>{data.product_block?.name}</div>;
    },
  },
  {
    Header: "Proyek",
    accessor: "product_branch.name",
    filterable: true,
    Cell: (cell) => {
      let data = cell.row.original;
      return <div>{data.product_branch?.name}</div>;
    },
  },
  {
    Header: "Penjualan",
    accessor: (data) => data.product_sales.length && data.product_sales[0].sls_ds && data.product_sales[0].sls_ds.sales_customer ? data.product_sales[0].sls_ds.sales_customer.name : "",
    filterable: true,
    Cell: (cell) => {
      const data = cell.row.original;
      const sales = data.product_sales.length ? data.product_sales[0].sls_ds : null;
      const custName = sales && sales.sales_customer ? sales.sales_customer.name : "-";
      const agentName = sales && sales.sales_agent && <span className="badge text-uppercase badge-soft-info mt-1">{sales.sales_agent.name}</span>;
      return (
        <>
          <div>{custName}</div>
          {agentName}
        </>
      );
    },
  },
  {
    Header: "Dokumen PK",
    accessor: "sales_file",
    filterable: true,
    Cell: (cell) => {
      const data = cell.row.original;
      const sales = data.product_sales.length ? data.product_sales[0].sls_ds : null;
      return <div >
        {(sales?.sales_file || []).map((f, i) => {
          return (
            <div key={i}>
              <div className="d-flex mb-3">
                <div className="me-2">
                  {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                    <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                  ) : (
                    <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                      <i className="ri-file-pdf-line fs-3 text-danger"></i>
                    </Link>
                  )}
                </div>
                <div className="text-truncate mt-2">{f.originalname}</div>
              </div>
            </div>
          );
        })}
      </div>;
    },
  },
  {
    id: "Marketing",
    Header: "Marketing",
    accessor: "sales_agent.name",
    filterable: true,
  },
  {
    id: "Tanggal",
    Header: "Tgl BAST",
    accessor: (data) => data.handoverat ? handleValidDate(data.handoverat) : "-",
    filterable: false,
  },

  {
    id: "Kunci",
    Header: "Pos Kunci",
    accessor: "handover_key",
    filterable: true,
  },

  {
    id: "Aksesoris",
    Header: "Pos Aksesoris",
    accessor: "handover_acc",
    filterable: true,
  },

  {
    id: "PK",
    Header: "Pos PK",
    accessor: "handover_pk",
    filterable: true,
  },
  {
    id: "Keterangan",
    Header: "Keterangan",
    accessor: "handover_desc",
    filterable: true,
  }],
    [productHandoverList, handleProductHandoverClick, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = productHandoverList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setProductHandoverList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => productHandoverList, [productHandoverList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Marketing", "Status", "Proyek", "Blok"],
        pageIndex: indexPage,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "requested",
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetProductHandover(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setProductHandoverList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetProductHandoverState());
    dispatch(onGetProductHandover({ branchId: branchSelected?.value ?? "" }));
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      productId: productHandover && productHandover.productId,
      handover: (productHandover && productHandover.handover) || [],
      handoverat: (productHandover && productHandover.handoverat) ?? "",
      handover_key: (productHandover && productHandover.handover_key) ?? "",
      handover_acc: (productHandover && productHandover.handover_acc) ?? "",
      handover_pk: (productHandover && productHandover.handover_pk) ?? "",
      handover_desc: (productHandover && productHandover.handover_desc) ?? "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(getProductHandoverLoading());
      if (values.productId.value > 0) {
        let editSubmit = {
          id: values.productId.value,
          handover_production: values.handover,
          handoverat: values.handoverat,
          handover_desc: values.handover_desc,
          handover_key: values.handover_key.value,
          handover_acc: values.handover_acc.value,
          handover_pk: values.handover_pk.value,
        };
        dispatch(onUpdateProductHandover(editSubmit));
      } else {
        toast.error("Silahkan isi unit yang diserah terimakan", { position: "bottom-left", autoClose: 5000 });
      }
      validation.resetForm();
      toggle();
    },
  });

  const [expandedRowId, setExpandedRowId] = useState(null);
  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id);
  };

  document.title = "Serah Terima Unit | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={productHandoverList} />
      <Container fluid>
        <BreadCrumb title="BAST" pageTitle="Serah Terima Unit">
          <div className="flex-shrink-0">
            <button
              type="button"
              className="btn btn-primary add-btn me-2"
              id="create-btn"
              onClick={() => {
                handleProductHandoverClick([]);
                setIsEdit(false);
              }}
            >
              <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={productHandoverDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div className="border-top">
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            {/* <i className="bx bx-search-alt search-icon"></i> */}
                          </div>
                        </Col>

                        <Col sm={2}>
                          <div className="me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              value={filterDate}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            {/* <i className="bx bx-calendar-alt search-icon"></i> */}
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1" style={{ minHeight: "320px" }}>
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          const dataRow = row.original;
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr className="cursor-pointer" onClick={() => {
                                handleRowClick(row.id);
                                setInfo(dataRow);
                              }}>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                              {expandedRowId === row.id && (
                                <tr className="bg-light">
                                  <td></td>
                                  <td colSpan="9" className="cursor-pointer">
                                    <div className="row">
                                      {(dataRow.handover_production).map((row, idx) => {
                                        return (
                                          <div className="fs-10 text-muted col-lg-6" key={idx}>
                                            <div className="mb-1">
                                              <i className={row.id ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line text-danger me-1"}></i> {row.name ? row.name : "-"}  {row.Aktualat ? row.Aktualat : ""}
                                            </div>
                                            {row.description && row.description !== "" && (
                                              <div className="mb-1">
                                                {row.description ? row.description : "-"}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} value={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Form Berita Acara Serah Terima" : "Form Berita Acara Serah Terima"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className="pt-0 pb-4 ps-4 pe-4">
                        <div className="row mb-5">
                          <div className="col-lg-6">
                            <div className="mb-3">
                              <label className="form-label" htmlFor="productId">
                                BLOK / Unit
                              </label>
                              <Select
                                name="productId"
                                placeholder="Pilih Unit"
                                value={validation.values.productId}
                                onChange={(e) => {
                                  validation.setFieldValue("productId", e);
                                }}
                                options={productList}
                              ></Select>
                              {validation.touched.productId && validation.errors.productId && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.productId}
                                </small>
                              )}
                            </div>

                            <div className="mb-3">
                              <label className="form-label" htmlFor="productId">
                                Tanggal BAST
                              </label>
                              <Flatpickr
                                className="form-control"
                                placeholder="Pilih Tanggal BAST"
                                options={{ mode: "single", dateFormat: "Y/m/d" }}
                                onChange={(selectedDates, dateStr) => {
                                  validation.setFieldValue("handoverat", dateStr);
                                }}
                                value={validation.values.handoverat}
                              />
                            </div>
                            <div className="mb-2">
                              <Label htmlFor="pekerjaan-field" className="form-label">
                                Keterangan
                              </Label>
                              <Input
                                type="textarea"
                                className="form-control"
                                placeholder="Keterangan jika ada"
                                value={validation.values.handover_desc}
                                onChange={(e) => {
                                  validation.setFieldValue("handover_desc", e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="mb-3">
                              <Label htmlFor="pekerjaan-field" className="form-label">
                                Posisi Kunci
                              </Label>
                              <Select
                                name="handover_key"
                                value={validation.values.handover_key}
                                placeholder="Pilih Posisi Kunci"
                                onChange={(e) => {
                                  validation.setFieldValue("handover_key", e);
                                }}
                                options={posData}
                              ></Select>
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="pekerjaan-field" className="form-label">
                                Posisi Aksesoris
                              </Label>
                              <Select
                                name="handover_acc"
                                value={validation.values.handover_acc}
                                placeholder="Pilih Posisi Aksesoris"
                                onChange={(e) => {
                                  validation.setFieldValue("handover_acc", e);
                                }}
                                options={posData}
                              ></Select>
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="pekerjaan-field" className="form-label">
                                Posisi PK
                              </Label>
                              <Select
                                name="handover_pk"
                                value={validation.values.handover_pk}
                                placeholder="Pilih Posisi PK"
                                onChange={(e) => {
                                  validation.setFieldValue("handover_pk", e);
                                }}
                                options={posData}
                              ></Select>
                            </div>
                          </div>


                        </div>
                        {handoverListEngineerings.map((o, idx) => {
                          if (validation.values.handover.length > 0) {
                            return (
                              <div key={idx} className="row ms-1">
                                <div className="form-check form-switch form-switch-custom form-switch-success mb-2 col-lg-3">
                                  <Input
                                    className={"form-check-input checked-all checked-method-all check-" + o.id + idx}
                                    type="checkbox"
                                    role="switch"
                                    value={validation.values.handover[idx]?.id}
                                    defaultChecked={o.id === validation.values.handover[idx]?.id && validation.values.handover[idx]?.id !== 0 ? true : false}
                                    onChange={(e) => {
                                      if (e.target.checked) validation.setFieldValue(`handover[${idx}].id`, o.id);
                                      else validation.setFieldValue(`handover[${idx}].id`, 0);
                                    }}
                                  />
                                  <Label className="form-check-label text-dark text-uppercase" htmlFor={"check-" + o.id + idx}>
                                    {o.name}
                                  </Label>
                                </div>
                                <div className="mb-2 col-lg-2">
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Target"
                                    options={{ mode: "single", dateFormat: "Y/m/d" }}
                                    onChange={(selectedDates, dateStr) => {
                                      validation.setFieldValue(`handover[${idx}].targetat`, dateStr);
                                    }}
                                    value={validation.values.handover[idx]?.targetat}
                                  />
                                </div>
                                <div className="mb-2 col-lg-2">
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Aktual"
                                    options={{ mode: "single", dateFormat: "Y/m/d" }}
                                    onChange={(selectedDates, dateStr) => {
                                      if (validation.values.handover[idx]) validation.values.handover[idx].Aktualat = dateStr;
                                    }}
                                    value={validation.values.handover[idx]?.Aktualat}
                                  />
                                </div>
                                <div className="mb-2 col-lg-5">
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Keterangan jika ada"
                                    value={validation.values.handover[idx]?.description}
                                    onChange={(e) => {
                                      validation.setFieldValue(`handover[${idx}].description`, e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          } else return null;
                        })}
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            validation.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {"SIMPAN DATA"}&nbsp;
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
ProductHandover.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(ProductHandover));
